import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import OrderProp from '../../propTypes/orderProp';

function ButtonsContainer(props) {
  const { t, order, onCreditNotesClick, isOpportunity } = props;
  const { refundCreditNotes } = order;

  return (
    <div className="button-container">
      {refundCreditNotes?.length > 0 && !isOpportunity ? (
        <button
          type="button"
          onClick={() => onCreditNotesClick(refundCreditNotes)}
          className="creditNotes-btn btn btn-outline-primary btn-md m-btn--pill"
        >
          <span>
            <span>{t('shop.order_download.creditNotes.open')}</span>
          </span>
        </button>
      ) : null}
    </div>
  );
}

ButtonsContainer.propTypes = {
  t: PropTypes.func.isRequired,
  onCreditNotesClick: PropTypes.func.isRequired,
  order: PropTypes.shape(OrderProp.propType).isRequired,
  isOpportunity: PropTypes.bool,
};

ButtonsContainer.defaultProps = {
  isOpportunity: false,
};

export default translate(ButtonsContainer);
